<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xOXLIl/tc-custom/9780547504209.jpg?1734333772154" alt="This image is the cover for the book Rodin's Debutante"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rodin's Debutante
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A “beguiling and unnerving” novel of a young man haunted by an act of violence, from the award-winning author of <i>An Unfinished Season</i> (<i>Booklist</i>, starred review).</b><br/>  <br/> As a small-town boy in the early twentieth century, Lee Goodell learned about a brutal crime—and the efforts of his father, a judge, to help cover it up. Lee would go on to attend a private boys’ school, become a sculptor, become familiar with both Chicago’s gritty South Side and its wealthy, intellectual Hyde Park, and get married. But it is his reunion with a girl from his childhood, a victim of a sexual assault she cannot remember, that will spur him to contemplate the event that marked the end of his boyhood and the beginning of his understanding of the world, in this sprawling, powerful novel by “one of the most accomplished and admirable American writers” (<i>The Washington Post Book World</i>).<br/>  <br/> “An achievement . . . [that] fuses the romanticism of the early Kerouac and his mentor, Thomas Wolfe, with the wry humor of Richard Yates.” —<i>The </i><i>New York Times Book Review</i><br/>  <br/> “<i>Rodin’s Debutante</i> is a surprising story, never going where you expect it to, and Just’s spare prose packs a solid emotional punch.” —<i>Entertainment Weekly</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ward Just
      </h2>
      
      <p class="authorDescription body article">Ward Just&#39;s novels include <I>Exiles in the Garden</I>, <I>Forgetfulness</I>, the National Book Award finalist <I>Echo House</I>, <I>A Dangerous Friend</I>, winner of the Cooper Prize for fiction from the Society of American Historians, and <I>An Unfinished Season</I>, winner of the Chicago Tribune Heartland Award and a finalist for the 2005 Pulitzer Prize.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67ef68fc